import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import schema from "./schema";

const FileUploader = ({
  uploadUrl,
  setNeedRefetch,
  setIsCreateBlackListModalOpen
}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState(null);

  const [products, setProducts] = useState([]);

  const [formData, setFormData] = useState({
    documentType: "CPF",
    document: "",
    queryTypes: [],
    observation: "",
    active: true
  });

  const getProducts = async () => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/black_list_document/products"
    );
    setProducts(response.data.data);
  };

  useEffect(() => {
    getProducts();
  }, []);

  const handleFileChange = event => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
      setMessage(null);
    }
  };

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleQueryTypeChange = e => {
    const { value, checked } = e.target;
    const numericValue = parseInt(value);

    setFormData(prev => {
      if (checked) {
        return { ...prev, queryTypes: [...prev.queryTypes, numericValue] };
      } else {
        return {
          ...prev,
          queryTypes: prev.queryTypes.filter(id => id !== numericValue)
        };
      }
    });
  };

  const validateForm = async () => {
    try {
      await schema.validate(formData, { abortEarly: false });
      return true;
    } catch (err) {
      if (err.inner) {
        err.inner.forEach(e => toast.error(e.message));
      } else {
        toast.error(err.message);
      }
      return false;
    }
  };

  const handleUpload = async () => {
    const isValid = await validateForm();
    if (!isValid) return;
    const data = new FormData();
    data.append("documentType", formData.documentType);
    data.append("document", formData.document);
    formData.queryTypes.forEach(item => {
      data.append("queryType", item);
    });
    data.append("active", formData.active);

    if (formData.observation) {
      data.append("observation", formData.observation);
    }
    if (file) {
      data.append("attachment", file);
    }

    setUploading(true);
    setMessage(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/${uploadUrl}`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );

      setMessage("Upload realizado com sucesso!");
      setFile(null);
      setNeedRefetch(true);
      toast.success("Sucesso ao criar o documento");
      setIsCreateBlackListModalOpen(false);
    } catch (error) {
      setMessage(
        `Erro no upload: ${error.response?.data?.message || error.message}`
      );
    } finally {
      setUploading(false);
    }
  };

  if (!products || products.length <= 0) {
    return <>Carregando...</>;
  }

  return (
    <div
      style={{
        padding: "1rem",
        border: "1px solid #ccc",
        borderRadius: "8px",
        maxWidth: "600px"
      }}
    >
      <h2>Upload de Documento</h2>

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Tipo de Documento:
          <select
            name="documentType"
            value={formData.documentType}
            onChange={handleInputChange}
            style={{ marginLeft: "0.5rem" }}
          >
            <option value="CPF">CPF</option>
            <option value="CNPJ">CNPJ</option>
            <option value="PLATE">Placa</option>
            <option value="PHONE">Telefone</option>
          </select>
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Documento:
          <input
            type="text"
            name="document"
            value={formData.document}
            onChange={handleInputChange}
            style={{ marginLeft: "0.5rem", padding: "0.25rem" }}
          />
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Tipos de Consulta:
        </label>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
          {products.map(option => (
            <label
              key={option.id}
              style={{ display: "flex", alignItems: "center" }}
            >
              <input
                type="checkbox"
                value={option.id}
                checked={formData.queryTypes.includes(option.id)}
                onChange={handleQueryTypeChange}
                style={{ marginRight: "0.25rem" }}
              />
              {option.name}
            </label>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Observações:
          <textarea
            name="observation"
            value={formData.observation}
            onChange={handleInputChange}
            style={{
              marginLeft: "0.5rem",
              padding: "0.25rem",
              width: "100%",
              minHeight: "80px"
            }}
          />
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            name="active"
            checked={formData.active}
            onChange={handleInputChange}
            style={{ marginRight: "0.5rem" }}
          />
          Documento ativo
        </label>
      </div>

      <div style={{ marginBottom: "1rem" }}>
        <label style={{ display: "block", marginBottom: "0.5rem" }}>
          Anexo:
          <input
            type="file"
            accept=".png,.jpg,.jpeg,.pdf"
            onChange={handleFileChange}
            style={{ marginLeft: "0.5rem" }}
          />
        </label>
        {file && <p>Arquivo selecionado: {file.name}</p>}
      </div>

      <button
        onClick={handleUpload}
        disabled={uploading}
        type="button"
        className="btn btn-primary"
      >
        {uploading ? "Enviando..." : "Enviar Documento"}
      </button>

      {message && (
        <p
          style={{
            marginTop: "1rem",
            color: message.includes("Erro") ? "red" : "green"
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default FileUploader;
